import { getCurrentCompetencia } from "@/utils/consignado/getCurrentCompetence.utils";

export enum CobrancaCltEnum {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  DIVERGENT = "DIVERGENT",
  SETTLED = "SETTLED",
  CANCELED = "CANCELED",
}

export enum CobrancaCltEnumPt {
  PENDENTE = "PENDENTE",
  SUCESSO = "SUCESSO",
  DIVERGENTE = "DIVERGENTE",
  LIQUIDADO = "LIQUIDADO",
  CANCELADO = "CANCELADO",
}

export type FilterByType = "competencia" | "pagamento" | "lembrete" | "status";

export enum TipoDisparoEmailEnum {
  NOVO_CONTRATO= 'NOVO_CONTRATO',
  ESCRITURACAO_ATRASADA= 'ESCRITURACAO_ATRASADA',
}

export enum NotificacaoEmailStatusEnum {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR"
}

export type Filters = {
  data_pagamento_inicio?: Date;
  data_pagamento_fim?: Date;
  status: string;
  corban: string;
  promotora: string;
  vendedor: string;
  gerente_comercial: string;
  periodo: string;
  empregador: string;
  tomador: string;
  codigo_proposta: string;
  pagina: number;
  limite: number;
  order?: "DESC" | "ASC";
  status_competencia?: CompetenciaStatusType;
  data_competencia?: string;
  tipo_disparo_email?: TipoDisparoEmailEnum;
  status_envio_email?: NotificacaoEmailStatusEnum;
  vinculo_ativo: boolean;
  novos_vinculos: boolean | undefined;
  metricas_vinculos: boolean | undefined;
};

export type BuscarCobrancaPropostaParams = {
  pagina?: number;
  limite?: number;
  status?: string;
  vendedor?: string;
  corban?: string;
  promotora?: string;
  gerente_comercial?: string;
  periodo?: string;
  tomador?: string;
  empregador?: string;
  codigo_proposta?: string;
  dataInicio?: Date;
  dataFim?: Date;
  status_envio_email?: string;
};

export interface ICobrancaRetorno {
  data: ICobrancaDetalheRetorno[];
  total: number;
  pagina: number;
  limite: number;
  total_paginas: number;
  proximo: any;
  anterior: any;
  metricas?: ICobrancaVinculoMetricas
}

export interface ICobrancaVinculoMetricas {
  encerrados: number;
  novos: number;
}

export interface ICobrancaDetalheRetorno {
  id: string;
  id_proposta?: string;
  proposta_shorthash: string;
  tomador_documento: string;
  tomador_nome: string;
  status: CobrancaCltEnumPt;
  competencias_resumo: ICompetenciaResumo[];
}

export type CompetenciaStatusType =
  | ""
  | "ESCRITURADO"
  | "NAO_ESCRITURADO"
  | "REPASSADO"
  | "NAO_REPASSADO";

export interface Contato {
  id: string;
  refId?: string;
  nome?: string;
  telefone?: string;
  email?: string;
  observacao?: string;
  tipo?: string;
  temperatura?: ContatoTemperaturaEnum;
  documento?: string;
}

export enum ContatoTemperaturaEnum {
  QUENTE = "QUENTE",
  FRIO = "FRIO",
}

// POST /proposta/contatos (CobrancaContatoDTO do backend). O DTO expõe o campo
// como `ref_id` (snake_case) na entrada, mas a entidade devolvida traz `refId`
// — por isso o request é um tipo próprio e não `Partial<Contato>`.
export interface ICriarContatoRequest {
  // UUID do tomador / empregador dono do contato.
  ref_id: string;
  // TOMADOR | EMPREGADOR
  tipo: string;
  nome?: string;
  telefone?: string;
  email?: string;
  observacao?: string;
  temperatura?: ContatoTemperaturaEnum;
}

// ── Seção "Dados de Contato" do detalhe da CCB — REAL (HIS-024 / TAR-049,
// backend his-adm-cobranca-020 `efab7a1f`).
// GET /proposta/cobrancas/:ccb/contatos devolve tomador e empregador já
// resolvidos a partir da cobrança, cada um com os contatos filtrados por tipo
// (corrige o defeito da rota antiga por referenciaId, que não filtrava tipo e
// dependia do front mandar o id certo). `endereco` do empregador pode vir null:
// a relação é nova e não houve preenchimento retroativo.
export type ParteContatoCobranca = "tomador" | "empregador";

export interface IEnderecoCobrancaRetorno {
  logradouro: string | null;
  numero: string | null;
  complemento: string | null;
  bairro: string | null;
  cidade: string | null;
  uf: string | null;
  cep: string | null;
}

export interface IParteContatoCobrancaRetorno {
  id: string | null;
  nome: string | null;
  documento: string | null;
  endereco: IEnderecoCobrancaRetorno | null;
  contatos: Contato[];
}

export interface IContatosCobrancaRetorno {
  cobranca_id: string;
  numero_ccb: string;
  tomador: IParteContatoCobrancaRetorno;
  empregador: IParteContatoCobrancaRetorno;
}

// PUT /proposta/contatos/:id — só estes campos são editáveis (AtualizarContatoDto);
// `documento` e `tipo` não.
export type IAtualizarContatoRequest = Partial<
  Pick<Contato, "nome" | "telefone" | "email" | "observacao" | "temperatura">
>;

// PUT /proposta/cobrancas/:ccb/contatos/:parte/endereco (AtualizarEnderecoDto).
export type IAtualizarEnderecoRequest = Partial<{
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
}>;


export interface ICobrancaDetailRetorno {
  id: string;
  id_proposta: string;
  proposta_shorthash: string;
  numero_ccb: string;
  proposta_criacao: string;
  tomador_id: string;
  tomador_documento: string;
  tomador_nome: string;
  vendedor_id: string;
  vendedor_nome: string;
  corban_id: number;
  corban_nome: string;
  promotora_id: number | null;
  promotora_nome: string | null;
  gerente_comercial_id: string;
  gerente_comercial_nome: string;
  empregador_id: string;
  empregador_nome: string;
  empregador_documento: string;
  status: string;
  parcelas: number;
  taxa_juros: number | null;
  valor_liberado: string;
  valor_descontado: string;
  data_criacao: string;
  data_atualizacao: string;
  competencias_divergentes: string[] | null;
  competencias_resumo: ICompetenciaResumo[];
  vinculo_ativo: boolean;
  motivo_desligamento_codigo: number;
  motivo_desligamento: string;
  comprovante_desligamento_url: string;
  etapaNegociacaoStatus: string | null;
  negociacaoDados: IRenegotiationStatusData | null;
}

export interface INegociacao {
  id?: string;
  cobranca_clt_id?: string;
  cobranca_competencia_id?: string;
  data_contato: string;
  status: string;
  competencia: string;
  descricao: string;
  data_criacao?: string;
  data_atualizacao?: string;
}

// PUT /proposta/cobrancas/negociacoes/:id — HIS-024 / TAR-048 (backend
// `efab7a1f`, AtualizarNegociacaoDto). Não aceita `cobranca_competencia_id`,
// então o front não deixa trocar a competência na edição (mudar só o rótulo
// `competencia` desincronizaria do vínculo).
export type IAtualizarNegociacaoRequest = Partial<
  Pick<INegociacao, "data_contato" | "status" | "descricao">
>;

export interface ICompetenciaResumo {
  competencia_id: string;
  competencia: Date;
  status: string;
  status_escrituracao: CobrancaCltEnum;
  status_repasse: CobrancaCltEnum;
  valor_parcela: number;
  notificacao_email: INotificacaoEmailCompetencia;
}

export interface INotificacaoEmailCompetencia {
  lembrete_novo_contrato?: INotificacaoEmail;
  escrituracao_em_atraso?: INotificacaoEmail;
}

export interface INotificacaoEmail {
  tipo: "EMPREGADOR" | "TOMADOR";
  status: "SUCCESS" | "ERROR";
  envios: INotificacaoEnvios[];
}

export interface INotificacaoEnvios {
  email: string;
  data_envio: Date;
  status: "SUCCESS" | "ERROR";
}

export interface ICompetenciaDetalhe {
  id: string;
  cobranca_clt_id: string;
  escrituracao_id: string | null;
  repasse_id: string | null;
  data_competencia: string;
  status_escrituracao: string | null;
  status_repasse: string | null;
  status: string;
  escrituracao_detalhe: IEscrituracaoDetalhe;
  repasse_detalhe: IRepasseDetalhe;
  data_criacao: string;
  data_atualizacao: string;
  valor_parcela: number;
  periodo_escrituracao: string;
  data_pagamento: Date | string;
  id_proposta: string;
}

export interface IRepasseDetalhe {
  valor_parcela_paga: number;
  numero_guia: string;
  data_pagamento_guia: Date;
  tem_divergencia?: boolean;
  divergencia_valor?: number;
  mensagem_divergencia?: string | null;
  data_hora_inclusao_dataprev: Date;
  data_hora_repasse_if: Date;
  contrato: string;
}

export interface IEscrituracaoDetalhe {
  data_hora_inclusao_dataprev: Date;
  data_hora_evento_exclusao: Date;
  data_hora_evento_retificacao: Date;
  valor_parcela: number;
  valor_parcela_desconto: number;
  tem_divergencia?: boolean;
  divergencia_valor?: number;
  mensagem_divergencia?: string | null;
  contrato: string;
}

export interface ITerminoVinculoEmprestimo {
  id: string;
  contrato: string;
  data_desligamento: Date;
  competencia_fim_desconto: string;
  data_hora_atualizacao: Date;
  situacao_emprestimo_codigo: number;
  situacao_emprestimo_descricao: string;
  qtd_pagamentos: number;
  qtd_escrituracoes: number;
}

export interface INovoVinculoCobranca {
  id: string;
  cpf: string;
  matricula: string;
  nome_trabalhador: string;
  inscricao_empregador_codigo: number;
  inscricao_empregador_descricao: string;
  numero_inscricao_empregador: string;
  nome_empregador: string;
  codigo_categoria_trabalhador: number;
  data_admissao: string;
  elegivel: boolean;
  motivo_inelegibilidade_codigo: number | null;
  motivo_inelegibilidade_descricao: string | null;
  valor_total_vencimentos: number;
  valor_base_margem: number;
  valor_margem_disponivel: number;
  pessoa_exposta_politicamente_codigo: number;
  pessoa_exposta_politicamente_descricao: string;
  qtd_emprestimos: number;
}

export interface ISeguroNegociacaoRetorno {
  id: string;
  cobranca_clt_id: string;
  data_contato: string;
  descricao: string;
  status: string;
}

export interface ISeguroNegociacaoCreate {
  data_contato: string;
  descricao: string;
  status: NegociacaoStatusEnum;
}

// PUT /cobrancas/seguros/negociacoes/:id (HIS-030 / TAR-060) — todos opcionais.
export type ISeguroNegociacaoUpdate = Partial<ISeguroNegociacaoCreate>;

export interface IComprovanteDesligamentoUrlRetorno {
  comprovante_desligamento_url: string | null;
}

// POST /cobrancas/:id/comprovante-desligamento passou a ser síncrono (TAR-060):
// devolve a URL do PDF na própria resposta.
export interface IComprovanteDesligamentoGeradoRetorno {
  url: string;
}

// GET /proposta/cobrancas/:ccb/resumo-financeiro (backend his-adm-cobranca-020,
// TAR-ADM-cobranca-038 `c655b112` / `85a8b382`).
// Seção "Resumo Financeiro" + tabela "Parcelas" do detalhe da CCB, numa rota só.
// Vale para vínculo ativo e encerrado — motivo_encerramento / data_desligamento
// só vêm quando há término de vínculo registrado. saldo_devedor_total /
// primeiro / ultimo vencimento são agregados PELO BACKEND (soma/min/max das
// parcelas). Se não houver resumo no banco, o backend sincroniza com a BMP e
// tenta de novo; se ainda não houver, 404.
export interface IResumoFinanceiroCobrancaRetorno {
  numero_ccb: string;
  valor_financiado: number;
  total_pago: number;
  numero_parcelas: number;
  valor_parcela: number;
  saldo_devedor_total: number;
  primeiro_vencimento: string | null;
  ultimo_vencimento: string | null;
  assinatura_contrato: string | null;
  motivo_encerramento: string | null;
  data_desligamento: string | null;
  // Ordenadas por número da parcela ASC.
  parcelas: IParcelaDetalhadaRetorno[];
}

// Retorno de GET /proposta/cobrancas/:ccb/relatorio-situacao-parcelas
// (TAR-ADM-cobranca-041, backend his-adm-cobranca-020 `7bcfad0c`). O backend
// consulta as parcelas na BMP, gera o PDF e sobe no storage; `url` é o link do
// arquivo. Período (opcional, yyyy-MM-dd) filtra pelo VENCIMENTO da parcela.
// nome_arquivo é determinístico por CCB + período: regerar sobrescreve o mesmo
// blob e a URL continua válida. gerado_em / referencia_dados são ISO.
export interface IRelatorioSituacaoParcelasRetorno {
  url: string;
  nome_arquivo: string;
  gerado_em: string;
  referencia_dados: string;
  periodo: { inicio: string | null; fim: string | null };
  quantidade_parcelas: number;
}

// ── Relatório de quitação (TAR-ADM-cobranca-043/044, backend
// his-adm-cobranca-020 `65a9ba13`) ──
// POST /proposta/cobrancas/:ccb/relatorio-quitacao. Espelha
// GerarRelatorioQuitacaoDto. Fonte: POST /contrato/parcela/consultar da BMP →
// VlrSaldoAtualizado por parcela para a data de cálculo. O valor é DATADO:
// vale para `data_calculo` (o backend devolve `valido_ate`).
// `total_quitacao` vem PRONTO do backend ([[no-front-calculations]]).
// Erros com `message` pro operador: 400 (data/parcela inexistente na CCB),
// 404 (CCB sem proposta), 422 (BMP sem cálculo), 503 (BMP fora).
export interface IGerarRelatorioQuitacaoRequest {
  // Números das parcelas (NroParcela), ≥ 1.
  parcelas: number[];
  // yyyy-MM-dd. Opcional no backend (default hoje); o front manda sempre.
  data_calculo?: string;
  // Opcional no backend (default false); o front manda sempre.
  permite_descapitalizacao?: boolean;
}

export interface IRelatorioQuitacaoRetorno {
  url: string;
  // Determinístico por CCB + data de cálculo + parcelas + flag: regerar
  // sobrescreve o mesmo blob.
  nome_arquivo: string;
  // ISO
  gerado_em: string;
  // yyyy-MM-dd
  data_calculo: string;
  // yyyy-MM-dd
  valido_ate: string;
  permite_descapitalizacao: boolean;
  parcelas: number[];
  quantidade_parcelas: number;
  total_quitacao: number;
}

// ── Reprocessar cobranças (backend his-adm-cobranca-020 `609712a7`) ──
// POST /proposta/cobrancas/ingerir-e-processar-dados-brutos?data_inicio&data_fim.
// Global (não é por CCB): ingere as 4 fontes da BMP no período e roda as etapas
// por flag em background. Responde na hora; EM_ANDAMENTO = já tem uma rodando.
export interface IReprocessarCobrancasRequest {
  // yyyy-MM-dd
  data_inicio: string;
  // yyyy-MM-dd
  data_fim: string;
}

export interface IReprocessarCobrancasRetorno {
  status: "OK" | "EM_ANDAMENTO";
  periodo?: { inicio: string; fim: string };
}

// ── Gerar / cancelar boleto (TAR-045, backend his-adm-cobranca-020 `8fbfa26c`) ──
// POST /proposta/cobrancas/:ccb/boletos. Espelha GerarBoletosCobrancaDto: só
// `parcelas` é obrigatório; o resto é override dos defaults do servidor
// (liquidação total, vencimento D+5, expiração = vencimento). Mandar SÓ o que
// o operador preencheu, pra não sobrescrever default com valor inventado pelo
// front. Exceção: via_boleto/via_pix vão SEMPRE explícitos (ao menos um true).
// As combinações ainda estão em teste na BMP (16/09): os dois true devolveu
// CON_001 e só PIX devolveu BMP_V0001_C0457; default do backend (`c878a530`)
// é boleto true E pix true. Um pedido cobre várias parcelas
// (NroParcelas[] da BMP); a BMP decide o agrupamento.
export interface IGerarBoletosCobrancaRequest {
  parcelas: number[];
  // yyyy-MM-dd
  data_vencimento?: string;
  // yyyy-MM-dd
  data_expiracao?: string;
  liquidacao_total?: boolean;
  // Obrigatório (≥ 0.01) quando liquidacao_total = false → 400 sem.
  valor_liquidacao?: number;
  // ≥ 0
  valor_desconto?: number;
  permite_descapitalizacao?: boolean;
  via_boleto?: boolean;
  via_pix?: boolean;
  descricao?: string;
  // Exige permissão ADMIN no usuário (403 sem) e motivo abaixo (400 sem).
  ignorar_escrituracao?: boolean;
  // Mínimo 10 caracteres.
  motivo_ignorar_escrituracao?: string;
}

export interface ICobrancaBoletoGerada {
  codigo_liquidacao: string;
  parcelas: number[];
}

// A geração NÃO devolve o boleto: ele só existe na BMP 30–90 s depois e entra
// em `parcelas[].boletos[]` do resumo financeiro quando a rotina de baixa
// (TAR-047) sincroniza. `codigo_liquidacao` == `boletos[].codigoCobranca`.
export interface IGerarBoletosCobrancaRetorno {
  ccb: string;
  cobrancas: ICobrancaBoletoGerada[];
  disponivel_em_segundos: number;
  mensagem: string;
}

// DELETE /proposta/cobrancas/:ccb/boletos/:codigoLiquidacao
export interface ICancelarBoletoCobrancaRetorno {
  ccb: string;
  codigo_liquidacao: string;
  parcelas: number[];
  mensagem: string;
}

export interface IErroBmp {
  codigo: string;
  mensagem: string;
}

// Corpo de erro (error.response.data) das duas rotas. `message` vem sempre.
//  409 COBRANCA_ATIVA          — parcela já tem cobrança ativa; `cobrancas` em
//                                camelCase (é assim que o backend manda no 409).
//  422 ESCRITURACAO_BLOQUEIA_COBRANCA — CON_002/CON_003 da BMP; `erros` traz a
//                                mensagem da BMP com a orientação da guia FGTS.
//  409 JA_CANCELADO / BOLETO_PAGO — só no cancelamento.
//  422 sem `codigo` — BMP não gerou/cancelou; `erros` explica.
//  400 validação · 403 ignorar_escrituracao sem ADMIN · 404 · 503 BMP fora.
export interface IBoletoCobrancaErroRetorno {
  statusCode?: number;
  codigo?: "COBRANCA_ATIVA" | "ESCRITURACAO_BLOQUEIA_COBRANCA" | "JA_CANCELADO" | "BOLETO_PAGO";
  message: string;
  erros?: IErroBmp[];
  cobrancas?: { codigoLiquidacao: string; parcelas: number[] }[];
}

// ── Parcelas / boletos ───────────────────────────────────────────────────
// Uma parcela como vem em `parcelas` do resumo financeiro
// (IParcelaDetalhadaRetorno do backend). Os campos planos em snake_case SÃO as
// colunas da tabela — usar só eles. Os aninhados (escrituracao,
// repassesPorPeriodo, boletos) são o bruto das entidades em camelCase, casados
// pela competência do vencimento, mantidos por compatibilidade com a rota
// antiga /consultar-resumo-parcelas.
//
// divergencia_*: vem da conciliação (cobranca_competencia), não de comparar
// valor no front. true = DIVERGENT, false = SUCCESS, null = a conciliação ainda
// não avaliou aquela competência (PENDING / competência inexistente) → travessão.
export interface IParcelaDetalhadaRetorno {
  numero_parcela: number | null;
  // AAAAMM derivado do vencimento (ex.: 202609).
  competencia: number | null;
  vencimento: string | null;
  // Código int da situação da parcela na BMP — o backend ainda não expõe o
  // mapeamento código → descrição.
  situacao: number | null;
  valor: number;
  saldo_atual: number;
  total_pago: number;
  data_escrituracao: string | null;
  // Colunas decimal do pg — podem chegar como string (não passam por paraNumero).
  valor_escriturado: number | string | null;
  divergencia_escrituracao: boolean | null;
  data_repasse: string | null;
  valor_repassado: number | string | null;
  divergencia_repasse: boolean | null;
  // Bruto da entidade Parcela (spread, camelCase).
  id: string;
  nroParcela?: number;
  dtVencimento?: string;
  dtVencimentoAtual?: string | null;
  vlrParcela?: number | string;
  vlrSaldoAtual?: number | string;
  vlrTotalPago?: number | string;
  vlrDesconto?: number | string;
  escrituracao: IEscrituracaoBruta | null;
  repassesPorPeriodo: IRepasseBruto | null;
  boletos: IBoletoDetalhadoRetorno[];
}

// Colunas selecionadas de `escrituracoes` (findPartialByCCBNumber).
export interface IEscrituracaoBruta {
  id: string;
  periodoReferencia: number;
  dataHoraInclusaoDataprev?: string | null;
  valorParcelaDesconto?: number | string | null;
  emprestimoValorParcela?: number | string | null;
  analiseValorParcelaCorreta?: boolean | null;
}

// Colunas selecionadas de `repasses` (findPartialByCCBNumber).
export interface IRepasseBruto {
  id?: string;
  repasseId?: number;
  valorParcelaPaga?: number | string | null;
  dataHoraPagamentoGuia?: string | null;
  dataHoraRepasseIf?: string | null;
  numeroGuia?: string | null;
  periodoReferencia?: number;
  analiseValorParcelaCorreta?: boolean | null;
}

// Boleto da parcela (entidade `boletos`, camelCase), como sai em
// `parcelas[].boletos[]` do resumo financeiro (backend his-adm-cobranca-020
// `21b1c930` amplia o select; `eed5fd00` adiciona `cancelado`).
// `codigoCobranca` é o `codigo_liquidacao` devolvido pela geração (TAR-045) e é o
// que o cancelamento recebe. `cancelado` vem do NOSSO registro de cancelamento
// (independe de a BMP já refletir). `pago` vem do backend (= `dtCredito`
// preenchido): `liquidacao` NÃO é status de pagamento — é o tipo do boleto
// (quita o saldo total vs. valor parcial), ecoado do `Liquidacao` que a
// geração manda pra BMP, e vem `true` em quase todo boleto. `parcelas_cobertas`
// lista as parcelas dessa mesma cobrança — a BMP devolve o boleto aninhado em
// cada uma delas, então ele aparece repetido linha a linha.
// qrCodeImagem fica de fora do select de propósito (base64 pesado).
export interface IBoletoDetalhadoRetorno {
  id: string;
  parcelaId: string;
  codigoCobranca: string;
  cancelado: boolean;
  numeroBoleto?: number;
  liquidacao?: boolean;
  pago?: boolean;
  parcelas_cobertas?: number[];
  dtCredito?: string | null;
  dtExpiracao?: string | null;
  linhaDigitavel?: string;
  operacaoBoletoRegistro?: number;
  situacaoBoletoRegistro?: number;
  descricaoBoletoRegistro?: string;
  urlImpressao?: string;
  qrCodeEmv?: string | null;
  motivoLancamentoCobranca?: number;
}

// A BMP não documenta a legenda do código `situacao`, então a leitura da
// parcela vem do saldo e do vencimento — mesma regra que o backend usa no
// relatório de situação das parcelas e no comprovante de desligamento.
// Compara pela data UTC, como `formatDateWithNoHours` exibe, pra tela e
// classificação nunca discordarem de um dia.
const diaUtc = (data: string | Date) => new Date(data).toISOString().slice(0, 10);

export const parcelaQuitada = (parcela: Pick<IParcelaDetalhadaRetorno, "saldo_atual">) =>
  Number(parcela.saldo_atual) <= 0;

export const parcelaVencida = (
  parcela: Pick<IParcelaDetalhadaRetorno, "saldo_atual" | "vencimento">,
) => {
  if (parcelaQuitada(parcela) || !parcela.vencimento) return false;
  return diaUtc(parcela.vencimento) < diaUtc(new Date());
};

export const boletoEstaPago = (boleto: Pick<IBoletoDetalhadoRetorno, "pago" | "dtCredito">) =>
  boleto.pago ?? Boolean(boleto.dtCredito);

export const boletoEstaExpirado = (boleto: Pick<IBoletoDetalhadoRetorno, "dtExpiracao">) =>
  Boolean(boleto.dtExpiracao && new Date(boleto.dtExpiracao).getTime() < Date.now());

// Espelha `cobrancasAtivasDaCcb` do backend: pago, expirado ou cancelado não
// bloqueia geração nova. Divergir daqui faz a tela oferecer o "Gerar boleto"
// que a API recusa com 409 COBRANCA_ATIVA — ou esconder o que ela aceitaria.
export const boletoEstaAtivo = (
  boleto: Pick<IBoletoDetalhadoRetorno, "pago" | "dtCredito" | "dtExpiracao" | "cancelado">,
) => !boleto.cancelado && !boletoEstaPago(boleto) && !boletoEstaExpirado(boleto);

// ─────────────────────────────────────────────────────────────────────────

// ── Redesign de Vínculos Ativos: o CCB "hidratado" no FE ──────────────────
// Shape de trabalho do FE, REAL a partir da linha de
// GET /proposta/cobrancas/empregador/:cnpj/vinculos-ativos (hidratarCcbAtivo):
// identidade, data de contratação, contadores e competências. Resumo
// financeiro + parcelas, contatos, negociações e histórico de notificações
// têm query própria por CCB e não ficam neste objeto.
export interface ICcbVinculoAtivo {
  // id da cobrança (cobranca_clt) — o mesmo valor de `cobranca_id`, desde que o
  // nível 2 passou a ler de cobranca_clt (TAR-054).
  id: string;
  // UUID da cobrança. É o que as seções do detalhe usam nas rotas por id.
  cobranca_id: string | null;
  numero_ccb: string;
  proposta_shorthash?: string | null;
  tomador_nome: string;
  tomador_documento: string;
  data_contratacao: string;
  // Contadores prontos — o front NÃO varre parcelas pra somar (backend devolve).
  // REAIS via GET /proposta/cobrancas/empregador/:cnpj/vinculos-ativos:
  // qtd_competencias = qtdeCobrancaCompetencia (total),
  // qtd_nao_escriturados = qtdeNaoEscriturados, qtd_nao_repassado = qtdeNaoRepassados.
  qtd_competencias: number;
  qtd_nao_escriturados: number;
  qtd_nao_repassado: number;
  competencias_resumo: ICompetenciaResumo[];
  // AAAAMM da competência em atraso mais antiga, pronta do backend.
  competencia_atraso_mais_antiga?: number | null;
  // Flag do backend (vinculos-ativos). undefined = rota não informa → sem badge.
  tem_negociacao?: boolean;
  // Contatos, negociações, sinistro (seguro / comprovante) e novos vínculos
  // NÃO vêm aqui: têm query própria por CCB (ContatosSection /
  // NegociacaoSection / SinistroSection / NovosVinculosSection).
  // Presentes só quando o vínculo tem desligamento.
  termino_vinculo?: ITerminoVinculoEmprestimo;
  motivo_desligamento?: string;
}

// Listagem agrupada por empregador — REAL:
// GET /proposta/cobrancas/empregadores/vinculos-ativos (backend his-adm-cobranca-020)
// Paginada + filtrada server-side. Devolve só a linha do empregador + contagem;
// os CCBs de cada um são carregados à parte (ainda mock).
export interface IVinculoEmpregadorRetorno {
  nome_empregador: string;
  cnpj: string;
  contratos_ativos: number;
  // AAAAMM da competência mais recente entre os contratos do card.
  // Só vem com `ordenar_por=competencia`; null = nenhuma competência gerada.
  competencia?: number | null;
  // AAAAMM da competência em atraso mais antiga entre os contratos do card.
  // Só vem com `ordenar_por=competencia`; null = nenhum em atraso.
  competencia_atraso_mais_antiga?: number | null;
}

export interface IVinculosEmpregadorRetorno {
  data: IVinculoEmpregadorRetorno[];
  pagina: number;
  limite: number;
  proximo: number | null;
  anterior: number | null;
  total: number;
  total_paginas: number;
}

// GET /proposta/cobrancas/empregador/:cnpj/vinculos-ativos → nível 2 — REAL
// (TAR-054, backend `e66679d0`). CCBs ativas lidas direto de cobranca_clt (só
// vem quem tem cobrança), paginadas e com os mesmos filtros do nível 1. É a
// mesma linha de Vínculos Encerrados sem os campos da badge de elegibilidade.
export interface BuscarCcbsEmpregadorParams {
  pagina?: number;
  limite?: number;
  order?: "ASC" | "DESC";
  ordenar_por?: OrdenacaoVinculosEmpregadorApi;
  tomador?: string;
  codigo_proposta?: string;
  recorte?: RecorteVinculosEmpregador;
  // CCBs com ao menos uma negociação nesse status. O backend compara direto com
  // cobranca_negociacao.status, então vai o valor gravado (NegociacaoStatusEnum).
  // Só o nível 2 aceita — o nível 1 (empregadores) não filtra por isso.
  status_negociacao?: NegociacaoStatusEnum;
}

export interface IVinculoAtivoEmpregadorRetorno {
  // id da cobrança (cobranca_clt) — é o `cobranca_id` que o nível 3 usa.
  id: string;
  numero_ccb: string;
  proposta_shorthash: string | null;
  tomador_nome: string;
  tomador_documento: string;
  status: CobrancaCltEnumPt | null;
  data_contratacao: string | null;
  motivo_desligamento_codigo: number | null;
  motivo_desligamento: string | null;
  comprovante_desligamento_url: string | null;
  termino_vinculo: ITerminoVinculoEmprestimo | null;
  competencias_resumo: ICompetenciaResumo[];
  qtd_competencias: number;
  // Só competências com prazo já vencido (competence_dates) contam como pendência.
  qtd_nao_escriturados: number;
  qtd_nao_repassado: number;
  // AAAAMM da competência em atraso mais antiga (escrituração ou repasse
  // vencido sem sucesso — mesma regra dos contadores). null = nenhuma.
  competencia_atraso_mais_antiga?: number | null;
  // Se a CCB tem negociação registrada. Opcional: Vínculos Encerrados estende
  // esta linha e pode não trazer o campo.
  tem_negociacao?: boolean;
}

export interface IVinculosAtivosEmpregadorRetorno {
  data: IVinculoAtivoEmpregadorRetorno[];
  pagina: number;
  limite: number;
  proximo: number | null;
  anterior: number | null;
  total: number;
  total_paginas: number;
}

// Filtro rápido de "Vínculos Ativos" — REAL (backend his-adm-cobranca-020
// `3da2c200`, query `recorte` de GET /proposta/cobrancas/empregadores/vinculos-ativos).
// Classificação do backend, por contrato: escriturados/repassado = ao menos uma
// competência com SUCCESS; nao_* = competência com prazo vencido
// (bookkeeping_end_date / payment_transfer_date) e status ≠ SUCCESS — no repasse,
// parcela paga por boleto não conta. O front NÃO classifica nada.
export type StatusFiltroRapido =
  | "TODOS"
  | "ESCRITURADOS"
  | "NAO_ESCRITURADOS"
  | "REPASSADO"
  | "NAO_REPASSADO";

export type RecorteVinculosEmpregador =
  | "todos"
  | "escriturados"
  | "nao_escriturados"
  | "repassado"
  | "nao_repassado";

export const recorteDoStatusFiltro = (status: StatusFiltroRapido): RecorteVinculosEmpregador =>
  status.toLowerCase() as RecorteVinculosEmpregador;

// TAR-ADM-cobranca-087 — `ordenar_por` das rotas de Vínculos Ativos (níveis 1 e
// 2). competencia ordena pela competência em atraso mais antiga: o
// empregador pela mais antiga entre os seus contratos; quem não tem atraso
// vai pro fim. `order` ASC = atraso mais antigo primeiro.
// Espelha o OrdenacaoVinculosEmpregadorEnum do backend: só `competencia`.
// Data de contratação é o padrão — vai sem `ordenar_por`.
export type OrdenacaoVinculosEmpregadorApi = "competencia";
export type OrdenacaoVinculosEmpregador = "data_contratacao" | OrdenacaoVinculosEmpregadorApi;

export const ordenarPorParaApi = (
  ordenarPor?: OrdenacaoVinculosEmpregador
): OrdenacaoVinculosEmpregadorApi | undefined =>
  ordenarPor === "data_contratacao" ? undefined : ordenarPor;

export interface BuscarVinculosEmpregadorParams {
  pagina?: number;
  limite?: number;
  order?: "ASC" | "DESC";
  ordenar_por?: OrdenacaoVinculosEmpregadorApi;
  tomador?: string;
  empresa?: string;
  codigo_proposta?: string;
  recorte?: RecorteVinculosEmpregador;
  // Mesmo filtro do nível 2. Vai também aqui pra lista de empresas e a
  // contagem do card respeitarem o status — até o backend aplicar no nível 1
  // (applyVinculosEmpregadorFilters), a rota ignora o parâmetro (sem whitelist).
  status_negociacao?: NegociacaoStatusEnum;
}

// ── Vínculos Encerrados — REAL (HIS-ADM-cobranca-029, backend his-adm-cobranca-020)
// GET /proposta/cobrancas/vinculos-encerrados. A classificação de elegibilidade
// ao seguro é do BACKEND (mesmo SQL do filtro `recorte` e da badge); o front só
// exibe. [[no-front-calculations]]
// Recortes com regra escrita (tabela do João, 17/09). Elegível ainda nos 30 dias
// de franquia após o desligamento vai para EM_FRANQUIA, não para NAO_ELEGIVEL
// (feedback dos testes, 21/09). Os de negativação saíram da tabela — não existem
// na API nem aqui.
export type StatusEncerradoBucket =
  | "SEM_SEGURO"
  | "NAO_ELEGIVEL"
  | "EM_FRANQUIA"
  | "ELEGIVEL_PARCIAL_MAIS_30_MAIOR_500"
  | "ELEGIVEL_MAIS_30_MENOR_500";

export type RecorteVinculosEncerrados = "todos" | Lowercase<StatusEncerradoBucket>;

export type ElegibilidadeSeguro = Lowercase<StatusEncerradoBucket> | null;

export type RenegociacaoVinculoEncerrado = "nunca_tentada" | "erro" | "averbada";

export interface BuscarVinculosEncerradosParams {
  pagina?: number;
  limite?: number;
  order?: "ASC" | "DESC";
  tomador?: string;
  codigo_proposta?: string;
  recorte?: RecorteVinculosEncerrados;
  renegociacao?: RenegociacaoVinculoEncerrado;
}

export interface IVinculoEncerradoRetorno extends IVinculoAtivoEmpregadorRetorno {
  elegibilidade_seguro: ElegibilidadeSeguro;
  // Textos prontos do backend; só preenchido quando `nao_elegivel`.
  motivos_nao_elegibilidade: string[];
  // VE: dias entre a data do desligamento e hoje. null sem término ingerido.
  dias_desde_desligamento: number | null;
  valor_parcela: number | null;
}

export interface IVinculosEncerradosRetorno {
  data: IVinculoEncerradoRetorno[];
  pagina: number;
  limite: number;
  proximo: number | null;
  anterior: number | null;
  total: number;
  total_paginas: number;
}

export type IElegibilidadeSeguroBadge = Pick<
  IVinculoEncerradoRetorno,
  "elegibilidade_seguro" | "motivos_nao_elegibilidade" | "dias_desde_desligamento" | "valor_parcela"
>;

// CCB de Vínculos Encerrados = shape do ativo (pra reaproveitar CcbRow/CcbDetalhe)
// + os campos da badge de elegibilidade.
export interface ICcbVinculoEncerrado extends ICcbVinculoAtivo, IElegibilidadeSeguroBadge {}
// ─────────────────────────────────────────────────────────────────────────

export interface IRenegotiationRequest {
  contrato: string;
  numeroParcelas: number;
  taxaMensal?: number;
}

export interface IRenegotiationSimulationResponse {
  CodigoRequisicao: string;
  Origem: string;
  Conteudo: IRenegotiationSimulationContent;
  Erros: IRenegotiationSimulationError[];
}

export interface IRenegotiationSimulationContent {
  ContratoRenegociado: IRenegotiatedContract;
  Simulacao: IRenegotiationSimulationResult;
}

export interface IRenegotiatedContract {
  NumeroContrato: string;
  DtCalculo: string;
  Parcelas: IRenegotiatedContractInstallment[];
}

export interface IRenegotiatedContractInstallment {
  NroParcela: number;
  DtVencimentoAtual: string;
  Calculado: {
    VlrMulta: number;
    VlrMora: number;
    VlrJurosContrato: number;
    VlrEncargos: number;
    VlrAbatimento: number;
    VlrSaldoAtualizado: number;
  };
}

export interface IRenegotiationSimulationResult {
  DtPrimeiroVencimento: string;
  Parcelas: IRenegotiationSimulationInstallment[];
}

export interface IRenegotiationSimulationInstallment {
  Parcela: number;
  Dias: number;
  DtVencimento: string;
  VlrSaldoDevedor: number;
  VlrAmortizacao: number;
  VlrJuros: number;
  VlrPrestacaoTotal: number;
  VlrJurosAcumulado: number;
  VlrJurosMensal: number;
}

export interface IRenegotiationSimulationError {
  Codigo?: string;
  Mensagem?: string;
}

export enum EtapaNegociacaoStatus {
  BUSCA_DADOS_VINCULO = 'buscaDadosVinculo',
  CADASTRAR_VINCULO = 'cadastrarVinculo',
  GERAR_RENEGOCIACAO = 'gerarRenegociacao',
  AVERBACAO = 'averbarRenegociacao',
  CONCLUIDA = 'concluida',
}

export interface IRenegotiationStepStatus {
  status: string;
  mensagem?: string;
}

export interface IRenegotiationStatusData {
  dados?: {
    cpfTrabalhador?: string;
    matricula?: string;
    numeroInscricaoEmpregador?: string;
    numeroParcelas?: number;
  };
  etapa?: Partial<Record<EtapaNegociacaoStatus, IRenegotiationStepStatus>>;
}

export interface IRenegotiationStatusResponse {
  status: string | null;
  negociacaoDados: IRenegotiationStatusData | null;
}

export type PageTypeCobranca = "RELATORIO" | "NOTIFICACOES";
export type PageLayoutCobranca = "ANALYTICS" | "FLAT_LIST";

export interface INotificacaoTipoRow {
  key: "lembrete_novo_contrato" | "escrituracao_em_atraso";
  label: string;
  tipo_disparo: TipoDisparoEmailEnum;
  destinatario: "EMPREGADOR" | "TOMADOR";
  status: NotificacaoEmailStatusEnum;
  envios: INotificacaoEnvios[];
}

export interface INotificacaoCompetenciaRow {
  id: string;
  cobranca_id: string;
  id_proposta?: string;
  proposta_shorthash: string;
  tomador_nome: string;
  tomador_documento: string;
  cobranca_status: string;
  competencia: Date;
  competencia_id: string;
  competencia_status: string;
  tipos: INotificacaoTipoRow[];
  total_envios: number;
  total_sucesso: number;
  total_erro: number;
}
export type PageConfigCobranca = {
  title: string;
  vinculoAtivo: boolean;
  layout: PageLayoutCobranca;
  getInitialDataCompetencia: () => string | undefined;
  filters: FiltersConfig,
  metricas?: MetricsConfig,
};

export type FiltersConfig = {
  novos_vinculos: {
    enabled: boolean;
    defaultValue?: boolean
  }
}

export type MetricsConfig = {
  enabled: boolean;
};

export const pageConfigCobranca: Record<PageTypeCobranca, PageConfigCobranca> = {
  RELATORIO: {
    title: "Relatório",
    layout: "ANALYTICS",
    vinculoAtivo: true,
    getInitialDataCompetencia: () => getCurrentCompetencia(),
    filters: {
      novos_vinculos: {
        enabled: false,
        defaultValue: undefined
      }
    }
  },
  NOTIFICACOES: {
    title: "Notificações",
    vinculoAtivo: true,
    layout: "FLAT_LIST",
    getInitialDataCompetencia: () => getCurrentCompetencia(),
    filters: {
      novos_vinculos: {
        enabled: false,
        defaultValue: undefined
      }
    }
  },
};

export interface ICobrancaRelatorio {
  competencia: string;
  parcelas: IRelatorioParcelaDetalhe[];
}

export interface IRelatorioParcelaDetalhe {
  mes: string;
  ano: string;
  competencia: string;
  escriturado: number;
  nao_escriturado: number;
  repassado: number;
  nao_repassado: number;
  total: number;
}

export enum NegociacaoStatusEnum {
  PENDENTE = 'Pendente',
  EM_ANDAMENTO = 'Em andamento',
  CONCLUIDA = 'Concluída'
}

export enum NotificacaoEventoEnum {
  SOLICITACAO_CONTATO_RH = "SOLICITACAO_CONTATO_RH",
  SOLICITACAO_CONTATO_RH_PENDENTE = "SOLICITACAO_CONTATO_RH_PENDENTE",
  EMPRESTIMO_CONTRATADO_AVISO_TOMADOR = 'EMPRESTIMO_CONTRATADO_AVISO_TOMADOR',
  APENAS_WHATSAPP_META = 'APENAS_WHATSAPP_META',
  APENAS_EMAIL = 'APENAS_EMAIL',
  EMAIL_DIRETO = 'EMAIL_DIRETO',
  EMPRESTIMO_PAGO_EMAIL_EMPREGADO = 'EMPRESTIMO_PAGO_EMAIL_EMPREGADO',
  EMPRESTIMO_PAGO_EMAIL_EMPREGADOR = 'EMPRESTIMO_PAGO_EMAIL_EMPREGADOR',
  EMPRESTIMO_PAGO_WHATSAPP_TOMADOR = 'EMPRESTIMO_PAGO_WHATSAPP_TOMADOR',
  PROPOSTA_EXPIRACAO_WHATSAPP_TOMADOR = 'PROPOSTA_EXPIRACAO_WHATSAPP_TOMADOR',
  CODIGO_SEGURANCA_WHATSAPP = 'CODIGO_SEGURANCA_WHATSAPP',
  COMPETENCIA_FASE1_RETENCAO_EMAIL_EMPREGADOR = 'COMPETENCIA_FASE1_RETENCAO_EMAIL_EMPREGADOR',
  COMPETENCIA_FASE2_ESCRITURACAO_EMAIL_EMPREGADOR = 'COMPETENCIA_FASE2_ESCRITURACAO_EMAIL_EMPREGADOR',
  COMPETENCIA_FASE3_ALERTA_ESCRITURACAO_EMAIL_EMPREGADOR = 'COMPETENCIA_FASE3_ALERTA_ESCRITURACAO_EMAIL_EMPREGADOR',
  COMPETENCIA_FASE4_ALERTA_DAE_EMAIL_EMPREGADOR = 'COMPETENCIA_FASE4_ALERTA_DAE_EMAIL_EMPREGADOR',
}

export interface INotificacaoItem {
  idNotificacao: string;
  eventoNotificacao: NotificacaoEventoEnum | string;
  dataDisparo: string;
  statusEntrega: 'SUCCESS' | 'ERROR';
  /** E-mail destinatário do envio. Opcional pra retrocompatibilidade — alguns
   * callers (ex: a aba Notificações) não tem essa informação por envio. */
  email?: string;
  /** Telefone destinatário — para eventos por WhatsApp/SMS/ligação. */
  telefone?: string;
}

export interface ICompetenciaComUltimaNotificacao {
  idCompetencia: string;
  idProposta: string;
  shortHashProposta: string;
  nomeTomador: string;
  documentoTomador: string;
  dataCompetencia: string;
  notificacoes: INotificacaoItem[];
}

export interface PagedCompetenciasNotificacoesResponse {
  data: ICompetenciaComUltimaNotificacao[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  previous: number | null;
  next: number | null;
}

export interface ICompetenciaHistoricoNotificacoes {
  idCompetencia: string;
  dataCompetencia: string;
  notificacoes: INotificacaoItem[];
}

export interface HistoricoNotificacoesPorCompetenciaResponse {
  idProposta: string;
  shortHashProposta: string;
  nomeTomador: string;
  documentoTomador: string;
  dataCompetencia: string;
  competencias: ICompetenciaHistoricoNotificacoes[];
}

// Histórico de notificações por CCB — REAL (TAR-ADM-cobranca-050, backend
// his-adm-cobranca-020 `72c3b158`): GET /proposta/cobrancas/:ccb/historico-notificacoes.
// Lista plana, da mais recente pra mais antiga, com as notificações das
// competências da CCB e as do contrato inteiro (`competencia: null`). Só lê a
// tabela `notificacoes` — contratos cujos envios ficaram na tabela antiga
// (`dispatch_notifications_info`) voltam com `total: 0`.
export interface IHistoricoNotificacaoCcbItem {
  id: string;
  /** `enviado_em ?? criado_em`; null se nenhum dos dois. */
  data_hora: string | null;
  /** CanaisNotificacaoEnum quando vem do módulo de notificação; string livre. */
  canal: string;
  destinatario: string;
  /** `nome` da notificação (= NotificacaoEventoEnum quando disparada pelo módulo
   * de notificação); senão `metadata.eventType`; senão o canal. String livre —
   * quem exibe precisa de fallback pra valor desconhecido. */
  tipo: string;
  /** SUCCESS só quando `status === 'ENVIADO'`; qualquer outro (inclusive
   * PENDENTE/ENVIANDO) sai ERROR. */
  status_envio: 'SUCCESS' | 'ERROR';
  /** PENDENTE | ENVIANDO | ENVIADO | FALHA */
  status: string;
  status_entrega: string | null;
  erro: string | null;
  competencia: { id: string; data: string } | null;
}

export interface IHistoricoNotificacoesCcbRetorno {
  numero_ccb: string;
  id_proposta: string;
  nome_tomador: string;
  documento_tomador: string;
  total: number;
  notificacoes: IHistoricoNotificacaoCcbItem[];
}

export type CanaisNotificacaoEnum =
  | "EMAIL" 
  | "WHATSAPP_VONEX" 
  | "SMS" 
  | "WHATSAPP_META" 
  | "WHATSAPP_META_OTP";

export interface IEnvioResultado {
  canal: CanaisNotificacaoEnum;
  status: 'ENVIADO' | 'FALHA';
  provedorMensagemId?: string | null;
  erro?: string;
}

export type ReenviarNotificacaoResponse = IEnvioResultado[];
